var map = {
	"./1.jpg": 8258,
	"./10.jpg": 9761,
	"./2.jpg": 1820,
	"./3.jpg": 2779,
	"./4.jpg": 1660,
	"./5.jpg": 586,
	"./6.jpg": 9475,
	"./7.jpg": 3021,
	"./8.jpg": 8644,
	"./9.jpg": 9940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9555;